<div [class.loading]="loader.loading">
    <div *ngIf="quickquote$ | async as quickquote">
        <div class="bootstrap beat-your-broker">
            <router-outlet></router-outlet>
        </div>
    </div>
</div>

<div class="apg-panel loader">
    <div class="loading" *ngIf="!error">
        <div class="invalid-feedback">Please wait...</div>
        <ion-spinner></ion-spinner>
    </div>
    <div class="loading " *ngIf="error">
        <div class="invalid-feedback" [innerHTML]="error"></div>
    </div>
</div>